export default "__VITE_ASSET__Da8sQ0v9__"